import { initSubRoutes } from '../../../../utils/router';

const RoutesCreerCompteEtape1 = initSubRoutes({
    route: '/etape-1',
    subroutes: {},
    nom: 'Création de compte - Première partie',
});

export default RoutesCreerCompteEtape1;
